export default "__VITE_ASSET__BPd9Fmkp__"